// External libraries
import styled from '@emotion/styled';

// Internal modules
import { SUB_HEADING_COLOR } from '@/styles';

export const LegalAgeDisclosureContainer = styled.p`
  color: ${SUB_HEADING_COLOR};
  font-size: 14px;
  line-height: 1.4;
`;
